"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using double colons with braces (`::` `::`).
 * Matches tags of the form `::{variable}::` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello ::{variable}::';
 * const result = replaceTags(text, { variable: 'world' }, DoubleColonsWithBraces);
 * console.log(result); // Output: 'Hello world'
 */
var DoubleColonsWithBraces = {
    name: "Double Colons With Braces",
    openingTag: "::{",
    closingTag: "}::",
    tagPattern: /::\{[^}]+\}::/g,
    tagStartPattern: /^::\{/,
    tagEndPattern: /\}::$/,
};
exports.default = DoubleColonsWithBraces;
